export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 10 },
    lg: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 },
    md: { span: 10 },
    lg: { span: 8 }
  }
};

export const noLabelLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { offset: 12, span: 10 },
    md: { offset: 10, span: 10 },
    lg: { offset: 8, span: 8 }
  }
};

export const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 14,
      offset: 8
    },
    md: {
      span: 12,
      offset: 8
    },
    lg: {
      span: 10,
      offset: 6
    }
  }
};

export const stepperTailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    md: {
      span: 18,
      offset: 2
    },
    lg: {
      span: 16,
      offset: 2
    },
    xl: {
      span: 14
    }
  }
};

export const drawerFormLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 10 },
    lg: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 },
    md: { span: 10 },
    lg: { span: 14 }
  }
};

export const drawerTailFormLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 10,
      offset: 10
    }
  }
};

export const preRequisitesLayout = {
  labelCol: {
    xs: { span: 22 }
  },
  wrapperCol: {
    xs: { span: 1, offset: 1 }
  }
};

export const verticalLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 10 },
    md: { span: 10 },
    lg: { span: 8 }
  }
};
